import { MEDIDAS_PREVENTIVAS } from "../constants/medidas_preventivas";

export function getMedidaPreventiva(
  key: keyof typeof MEDIDAS_PREVENTIVAS
): string {
  return MEDIDAS_PREVENTIVAS[key];
}
